const getAbTesting = state => state.abTesting;

const selectors = {
    makeTestExperiments: state => getAbTesting(state).testExperiments,
};

export default selectors;
